export default __webpack_public_path__ + "static/media/covid.7478a2ad.webp";